/**
 * Formats a list of unavailable filters into a human-readable string.
 * @param {Object} params - Function parameters.
 * @param {Array<{ label: string }>} params.filters - List of unavailable filters.
 * @param {Function} params.translate - Translation function (e.g., i18n.t).
 * @param {string} [params.locale="es"] - Language code (e.g., "es", "en").
 * @returns {string} Formatted text with translated filter labels.
 */
export const formatNotAvailableFiltersText = ({filters = [], i18n}) => {
  if (!filters.length) return ''

  const labels = filters.map(({label}) => label && i18n.t(label).toLowerCase()).filter(Boolean)

  return new Intl.ListFormat(i18n.language, {style: 'long', type: 'conjunction'}).format(labels)
}
